module.exports = "a.taskDue {\r\n  color: red;\r\n}\r\n"